// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"71f809d2","785":"a86a4f22"}[chunkId] + ".chunk.css";
};